import React from 'react';
import { Link } from 'react-router-dom';

import useStyles from './styles';

interface Props {
    title: string;
    description: string;
    link: string;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    className?: string;
}

const SubMenuItem: React.FC<Props> = ({ title, description, link, onClick, className }) => {
    const { classes, cx } = useStyles();

    return (
        <Link to={link} className={cx(classes.root, className)} onClick={onClick}>
            <span className={classes.primary}>{title}</span>
            <span className={classes.secondary}>{description}</span>
        </Link>
    );
};

export default SubMenuItem;
